import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../context/AlertContext";
import { useLoading } from "../../context/LoadingContext";
import { formatDate } from "../../commons/FormatValue";
import { filteredItemBySearch } from "../../utils/ManageArray";
import { getServiceRequest } from "../../commons/ServiceRequest";
import { initializeSetOption } from "../../utils/InitializeSetDefault";
import TableForm from "../TableForm";
import SearchFilter from "../SearchFilter";
import ConfirmModal from "../ConfirmModal";
import CardDisplayComponent from "../CardDisplayComponent";
import SeqOthersJobsService from "../../services/seqothersjob.service";
import SequenceStatusService from "../../services/sequencestatus.service";

const EditWorkOrderForm = ({ onSubmitCallback }) => {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [seqOther, setSeqOther] = useState([]);
  const [seqStatus, setSeqStatus] = useState([]);
  
  const defaultData = {
    Seq_Status_Id: "",
  };
  const [data, setData] = useState([]);

  const searchInput = [
    { name: "createdAt", type: "date", label: "วันที่ออกใบงาน" },
    { name: "Seq_Oth_No", label: "เลขที่ใบสั่งงาน", filterBy: ["Seq_Oth_No"] },
    {
      name: "InformOtherJob.JobType.Job_Type_Name",
      label: "ประเภทงาน",
      size: null,
      minKeywordLength: 1
    },
    {
      name: "InformOtherJob.JobTypeSub.Job_Type_Sub_Name",
      label: "ประเภทงานย่อย",
      size: null,
      minKeywordLength: 1
    }
  ];
  const inputField = [
    {
      name: "createdAt",
      label: "วันที่ออกใบสั่งงาน",
      format: (row) => formatDate(row),
      readOnly: true
    },
    { name: "Seq_Oth_No", label: "เลขที่ใบสั่งงาน", readOnly: true },
    {
      name: "InformOtherJob.Job_Name",
      label: "ชื่องาน",
      size: 3,
      readOnly: true
    },
    {
      name: "InformOtherJob.JobType.Job_Type_Name",
      label: "ประเภทงาน",
      readOnly: true
    },
    {
      name: "InformOtherJob.JobTypeSub.Job_Type_Sub_Name",
      label: "ประเภทงานย่อย",
      readOnly: true
    },
    {
      name: "Seq_Status_Id",
      label: "สถานะใบสั่งงาน",
      type: "select",
      filterBy: ["Seq_St_Name"],
      noneAsync: true,
      options: initializeSetOption({
        key: "Id",
        label: "Seq_St_Name",
        dataset: seqStatus
      })
    }
  ];

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);
    if (dataCallback) onSubmitCallback(dataCallback);
  };

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: SeqOthersJobsService.getAllSeqOthersJobs(),
      callback: (res) => setSeqOther(res)
    });
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: SequenceStatusService.getAllSequenceStatuses(),
      callback: (res) => setSeqStatus(res)
    });
  }, []);

  return (
    <>
      <CardDisplayComponent
        header={{
          title: { text: "แก้ไขสถานะใบสั่งงาน", className: "text-center" }
        }}
        body={{
          element: (
            <SearchFilter
              data={seqOther}
              inputField={searchInput}
              searchCallback={(search) =>
                setData(
                  search?.some(({ value }) => value)
                    ? filteredItemBySearch(seqOther, search)
                    : []
                )
              }
            />
          )
        }}
      />

      <Form noValidate validated={validated} onSubmit={handleValidated}>
        <CardDisplayComponent
          body={{
            element: (
              <TableForm
                editForm
                data={data||[]}
                columns={inputField || []}
                defaultData={defaultData}
                onChangeCallback={(newData) =>
                  setData(
                    newData?.map(({ Seq_Status_Id, ...item }) => ({
                      ...item,
                      Seq_Status_Id: Number(Seq_Status_Id)
                    }))
                  )
                }
              />
            )
          }}
          footer={{
            className: "text-end",
            element: (
              <>
                <Button
                  type="submit"
                  variant="success"
                  className="me-2 px-5 py-2 text-dark rounded-pill"
                >
                  บันทึกการแก้ไข
                </Button>
                <ConfirmModal
                  show={showModal}
                  data={{ data }}
                  content="edit"
                  onSubmitCallback={handleSubmit}
                />

                <Button
                  variant="outline-secondary"
                  className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                  onClick={() =>
                    navigate("/general_job/create", {
                      state: { name: "issue", type: "workorder" }
                    })
                  }
                >
                  ยกเลิก
                </Button>
              </>
            )
          }}
        />
      </Form>
    </>
  );
};

EditWorkOrderForm.propTypes = { onSubmitCallback: PropTypes.func };
export default EditWorkOrderForm;
